import { render } from "./AboutView.vue?vue&type=template&id=cda24016"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__